export type VendorCategory =
  | "DTF Equipment & General Suppliers"
  | "Parts & Repair"
  | "Ink, Film & Consumables"
  | "Printer Manufacturers & Dealer Networks"
  | "T-Shirt Wholesalers"
  | "Transfers, Printing & Decorators"
  | "Blanks & Specialty Products";

export interface Vendor {
  name: string;
  category: VendorCategory;
  tags?: string[];
  website?: string;
  contact?: string;
  notes?: string;
}

export interface FeaturedVendor {
  name: string;
  title: string;
  description: string;
  website?: string;
  platform?: string;
  poweredBy?: string;
  logo?: string;
  contact?: string;
  notes?: string;
  tags?: string[];
}

export const featuredVendors: FeaturedVendor[] = [
  {
    name: "Build A Gang Sheet / Drip Apps",
    title: "Exclusive Gang Sheet Builder inside DTF Wizard",
    description:
      "If you’re building gang sheets or offering them to customers, this is the platform to use. Clean interface, fast workflow, and built for real production — not guesswork. Widely used across the DTF industry, this system is designed for shops that want consistency, speed, and a better ordering experience.",
    website: "https://app.buildagangsheet.com/",
    platform: "Build A Gang Sheet",
    poweredBy: "Drip Apps",
    logo: "/vendors/buildagangsheet-logo.png",
    contact: "",
    notes:
      "Recommended inside DTF Wizard for gang sheet building, customer upload workflows, and smoother ordering experiences.",
    tags: [
      "Gang Sheet Builder",
      "Customer Uploads",
      "Ecommerce Workflow",
      "Production Friendly",
      "Shop Integration",
    ],
  },
  {
    name: "Creek Manufacturing",
    title: "DTF Equipment, Supplies & Printhead Maintenance",
    description:
      "If you're running DTF production and need reliable equipment, supplies, and maintenance solutions, Creek Manufacturing is a trusted name across the industry. Known for real-world shop products and practical solutions, Creek supports operators who need consistency and uptime — not guesswork.",
    website: "https://www.creekmanufacturing.com/",
    platform: "DTF Equipment & Supplies",
    poweredBy: "Creek Manufacturing",
    logo: "/vendors/creek-logo.png",
    contact: "",
    notes:
      "Maker of Purple Power — widely regarded by many in the DTF community as one of the most trusted printhead unclogging methods. Recommended inside DTF Wizard for equipment, supplies, and maintenance support.",
    tags: [
      "Equipment",
      "Supplies",
      "Printhead Maintenance",
      "Purple Power",
      "DTF Support",
    ],
  },
];

export const vendors: Vendor[] = [
  {
    name: "Apex Designs",
    category: "Transfers, Printing & Decorators",
    tags: ["DTF Transfers", "Gang Sheets", "Consumables", "Supplies"],
    website: "https://apexdesignsllc.com",
    contact: "orders@apexdesignsllc.com",
    notes: "DTF transfers, gang sheets, and supplies.",
  },
  {
    name: "Maggie Moo Printing",
    category: "Transfers, Printing & Decorators",
    tags: ["Custom Printing", "Consumables", "Supplies"],
    website: "https://maggiemooprintingokc.com/",
    contact: "",
    notes:
      "Custom printing services. Verify current DTF supplies or product offerings.",
  },
  {
    name: "RTS Sublimation Blanks",
    category: "Blanks & Specialty Products",
    tags: ["Blanks", "Apparel", "Sublimation"],
    website: "https://rtssublimationblanks.com/",
    contact: "",
    notes: "Sublimation blanks and apparel products.",
  },
  {
    name: "GAZ Transfers",
    category: "Transfers, Printing & Decorators",
    tags: ["DTF Transfers", "Consumables", "Supplies"],
    website: "https://gaztransfers.com/",
    contact: "",
    notes: "DTF transfers and printing services.",
  },
  {
    name: "TCH Designs DTF",
    category: "Transfers, Printing & Decorators",
    tags: ["DTF Transfers", "Gang Sheets", "Consumables", "Supplies"],
    website: "https://tchdesignsdtf.com/",
    contact: "",
    notes: "DTF transfers, gang sheets, and printing services.",
  },
  {
    name: "Okai Printer Company",
    category: "Printer Manufacturers & Dealer Networks",
    tags: ["Printers", "Equipment", "Manufacturer"],
    website: "https://okaimachinery.com/",
    contact: "",
    notes: "Manufacturer of Okai DTF printers and printing equipment.",
  },
  {
    name: "DTF One Stop",
    category: "DTF Equipment & General Suppliers",
    tags: ["Printers", "Parts", "Consumables", "Supplies"],
    website: "https://www.dtfonestop.com/",
    contact: "",
    notes: "DTF supplier with equipment, supplies, and support resources.",
  },
  {
    name: "DigiPrint Supplies",
    category: "Ink, Film & Consumables",
    tags: ["Ink", "Film", "Consumables", "Supplies"],
    website: "https://us.digiprint-supplies.com/",
    contact: "",
    notes:
      "Printer consumables, supply items, and technical support products.",
  },
  {
    name: "DTG PRO",
    category: "DTF Equipment & General Suppliers",
    tags: ["Printers", "Equipment", "Consumables", "Supplies"],
    website: "https://dtgpro.com/",
    contact: "",
    notes:
      "DTG and DTF equipment, supplies, and related production resources.",
  },
  {
    name: "DTF Superstore",
    category: "DTF Equipment & General Suppliers",
    tags: ["Printers", "Ink", "Film", "Powder", "Consumables"],
    website: "https://dtfsuperstore.com/",
    contact: "",
    notes: "DTF supply source for films, powders, inks, and equipment.",
  },
  {
    name: "OmniPrint Online",
    category: "Printer Manufacturers & Dealer Networks",
    tags: ["Equipment", "Printers", "Dealer Network"],
    website: "https://omniprintonline.com/",
    contact: "",
    notes:
      "Commercial garment printing equipment and related business support resources.",
  },
  {
    name: "InkJet Parts",
    category: "Parts & Repair",
    tags: ["Parts", "Repair", "Maintenance"],
    website: "https://inkjetparts.com/",
    contact: "",
    notes:
      "Parts-focused source for maintenance items, printhead components, and repair needs.",
  },
  {
    name: "InkSonic",
    category: "DTF Equipment & General Suppliers",
    tags: ["Printers", "Consumables", "Accessories", "Supplies"],
    website: "https://www.inksonic.com/",
    contact: "",
    notes: "DTF printer and supply source with consumables and accessories.",
  },
  {
    name: "ColDesi Shop",
    category: "Printer Manufacturers & Dealer Networks",
    tags: ["Equipment", "Accessories", "Supplies"],
    website: "https://shop.coldesi.com/",
    contact: "",
    notes:
      "Garment decoration equipment, accessories, supplies, and shop products.",
  },
  {
    name: "BCH Technologies",
    category: "Parts & Repair",
    tags: ["Parts", "Repair", "Maintenance", "Tools"],
    website: "https://bchtechnologies.com/",
    contact: "",
    notes:
      "Printer repair parts, maintenance products, tools, and technical resources.",
  },
  {
    name: "DTF Parts Store",
    category: "Parts & Repair",
    tags: ["Parts", "Repair", "Replacement Components"],
    website: "https://dtfpartsstore.com/",
    contact: "",
    notes:
      "Dedicated parts source for DTF printer repair and replacement components.",
  },
  {
    name: "Arcus Printers",
    category: "DTF Equipment & General Suppliers",
    tags: ["Printers", "Parts", "Accessories", "Support"],
    website: "https://arcusprinters.com/",
    contact: "",
    notes:
      "DTF printer supplier offering equipment, accessories, and support resources.",
  },
  {
    name: "DTF Bank",
    category: "DTF Equipment & General Suppliers",
    tags: ["Consumables", "Hardware", "Supplies"],
    website: "https://www.dtfbank.com/",
    contact: "",
    notes:
      "DTF-focused supplier offering consumables, hardware, and shop essentials.",
  },
  {
    name: "SanMar",
    category: "T-Shirt Wholesalers",
    tags: ["Blank Apparel", "Tees", "Fleece", "Wholesaler"],
    website: "https://www.sanmar.com/",
    contact: "",
    notes:
      "Major blank apparel wholesaler with tees, fleece, workwear, and brand-name basics.",
  },
  {
    name: "S&S Activewear",
    category: "T-Shirt Wholesalers",
    tags: ["Blank Apparel", "Tees", "Fleece", "Wholesaler"],
    website: "https://www.ssactivewear.com/",
    contact: "",
    notes:
      "Large wholesale blank apparel source with broad inventory and brand variety.",
  },
  {
    name: "Bulk Apparel",
    category: "T-Shirt Wholesalers",
    tags: ["Blank Apparel", "Tees", "Hoodies", "Wholesaler"],
    website: "https://www.bulkapparel.com/",
    contact: "",
    notes:
      "Blank apparel supplier focused on tees, hoodies, and printable basics.",
  },
  {
    name: "Royal Apparel",
    category: "T-Shirt Wholesalers",
    tags: ["Blank Apparel", "USA Made", "Specialty Garments"],
    website: "https://www.royalapparel.net/",
    contact: "",
    notes:
      "Blank apparel manufacturer and wholesaler offering USA-made and specialty garments.",
  },
  {
    name: "BELLA+CANVAS",
    category: "T-Shirt Wholesalers",
    tags: ["Blank Apparel", "Premium Tees", "Retail Style"],
    website: "https://www.bellacanvas.com/",
    contact: "",
    notes:
      "Premium apparel brand known for retail-style blanks, tees, and fleece.",
  },
  {
    name: "AllDayShirts",
    category: "T-Shirt Wholesalers",
    tags: ["Blank Apparel", "Tees", "Hoodies", "Budget Friendly"],
    website: "https://www.alldayshirts.com/",
    contact: "",
    notes:
      "Budget-friendly blank apparel source for tees, hoodies, and common print garments.",
  },
];

export const vendorCategoryOrder: VendorCategory[] = [
  "DTF Equipment & General Suppliers",
  "Parts & Repair",
  "Ink, Film & Consumables",
  "Printer Manufacturers & Dealer Networks",
  "Transfers, Printing & Decorators",
  "Blanks & Specialty Products",
  "T-Shirt Wholesalers",
];